import React from "react";
import "./App.css";
import { Toaster } from "sonner";
import { Header } from "./sections/Header";
import { Hero } from "./sections/Hero";
import { Portfolio } from "./sections/Portfolio";
import { Services } from "./sections/Services";
import { Testimonials } from "./sections/Testimonials";
import { ContactFooter } from "./sections/ContactFooter";
import { WhatsAppFloat } from "./sections/WhatsAppFloat";

function App() {
  return (
    <div className="App min-h-screen bg-bone text-charcoal" data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <Portfolio />
        <Services />
        <Testimonials />
        <ContactFooter />
      </main>
      <WhatsAppFloat />
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#1A1A1A",
            color: "#FAF9F6",
            border: "1px solid rgba(255,255,255,0.08)",
            borderRadius: "2px",
            fontFamily: "Inter, system-ui, sans-serif",
            fontSize: "13px",
            letterSpacing: "0.02em",
          },
        }}
      />
    </div>
  );
}

export default App;
